import React from "react";
import { Link } from "react-router-dom";

export default function Section1() {
  return (
    <div className="w-full h-[40vh] xs:h-[60vh] md:h-[73vh] min-[1101px]:h-[93vh] Section1">
      <div className="relative w-full h-full overflow-hidden section1-container font-open">
        <img
          className={`absolute top-0 left-0 items-center block object-cover w-full h-full object-center-center`}
          src="../../../../assets/banner-image-tiktok.png"
          alt="Tiktok Background Image"
        ></img>
        <div className="text-white top-auto bottom-[35px] xs:bottom-[35%]  mx-auto w-[95%]  absolute left-1/2 -translate-x-1/2 -translate-y-1/2  md:w-[750px]  md:mt-0 lg:w-[970px] lg:top-1/2 lg:bottom-auto xl:w-[1170px]">
          <div className="flex flex-wrap">
            <h3 className="text-lg mb-2 lg:text-[32px] z-10  relative py-[15px] pr-[20px] -ml-[2000px] pl-[2000px] before:-z-10 before:skew-x-[20deg] text-right  before:rounded-r-lg inline-block before:content-[''] before:w-full before:h-full before:bg-black/[0.6] before:absolute before:left-0 before:top-0">
              WE DELIVER<strong> RESULTS</strong>
            </h3>
            <Link
              to="/clients"
              className="lg:text-[18px] text-[13px] md:text-sm mb-2 p-[18px] xl:text-[21px] xl:px-[48px] before:skew-x-[20deg] transition-all inline-block relative text-center before:-z-10 z-10 cursor-pointer before:rounded-lg ml-[5px] before:bg-[#cd2122]/[0.7] hover:before:bg-[#cd2122]/[1] before:content-[''] before:w-full before:h-full  before:absolute before:left-0 before:top-0"
            >
              SEE PORTFOLIO
            </Link>
          </div>
          <h3 className="relative font-[500] text-sm md:text-[16px] py-[15px] pr-[16px] hidden xs:inline-block before:-skew-x-[20deg] before:-z-10 z-10 p-4 -ml-[2000px] pl-[2000px] text-right before:rounded-r-lg leading-[1] before:content-[''] before:w-full before:h-full before:bg-black/[0.4] before:absolute before:left-0 before:top-0">
            FOR HUNDREDS OF SUCCESSFUL BUSINESSES WORLDWIDE
          </h3>
        </div>
      </div>
    </div>
  );
}
